import React from 'react';
import '../../QueuePage.scss'

const ReassignCheckbox = ({ onCheckboxChange, isChecked }) => {

    const handleCheckboxClicked = (e) => {
        e.stopPropagation();
    }

    const handleCheckboxChanged = () => {
        onCheckboxChange(!isChecked);
    }

    return (
        <input className='queue-table-reassign-checkbox' type='checkbox' onChange={handleCheckboxChanged} onClick={handleCheckboxClicked} checked={isChecked} />
    )
}

export default ReassignCheckbox